import * as types from './constants'

const initialState = {
  searchByCourses: true,
  searchByGroups: false,
  roles: [],
  selectedRole: null,
  roleGroups: [],
  groupSearch: '',
}

const LearningPlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SEARCH_BY_COURSES:
      return {
        ...state,
        searchByCourses: action.searchByCourses,
      }
    case types.SET_SEARCH_BY_GROUPS:
      return {
        ...state,
        searchByGroups: action.searchByGroups,
      }
    case types.SET_ROLES_LEARNING_PLAN:
      return {
        ...state,
        roles: action.roles,
      }
    case types.SELECT_ROLE:
      return {
        ...state,
        selectedRole: action.role,
      }

    case types.SET_ROLE_GROUPS:
      return {
        ...state,
        roleGroups: action.data,
      }

    case types.SET_GROUP_SEARCH:
      return {
        ...state,
        groupSearch: action.payload,
      }

    default:
      return state
  }
}

export default LearningPlanReducer
